import React from 'react';

function TickHeavy(props) {
    const fill = props.fill;
    const className = props.className;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="18" 
            height="16" 
            viewBox="0 0 18 16" 
            fill="none"
            className={className}
        >
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M16.4819 1.43765C17.1239 2.0449 17.152 3.05758 16.5448 3.69952L7.21144 13.5662C6.91453 13.8801 6.50331 14.0605 6.0713 14.0665C5.63929 14.0725 5.22322 13.9035 4.91772 13.598L1.45105 10.1314C0.826212 9.50653 0.826212 8.49347 1.45105 7.86863C2.07589 7.24379 3.08895 7.24379 3.71379 7.86863L6.01722 10.1721L14.2201 1.50048C14.8273 0.858536 15.84 0.830406 16.4819 1.43765Z" 
                fill={fill}
            />
        </svg>
    )
};

export default TickHeavy;